export type HolidayKey =
  | "easter"
  | "midsummer"
  | "halloween"
  | "lucia"
  | "christmas";

export const HOLIDAY_KEYS: HolidayKey[] = [
  "easter",
  "midsummer",
  "halloween",
  "lucia",
  "christmas",
];

/** Värdet "none" i ?theme= stänger av den automatiska högtidsdetekteringen. */
export type HolidayOverride = HolidayKey | "none";

export type HolidayMode = "light" | "dark";

export const isHolidayKey = (
  value: string | null | undefined
): value is HolidayKey => !!value && (HOLIDAY_KEYS as string[]).includes(value);

export const isHolidayOverride = (
  value: string | null | undefined
): value is HolidayOverride => value === "none" || isHolidayKey(value);

/** Inklusivt datumintervall, båda ändar är lokala datum (kl 00:00). */
export interface DateRange {
  start: Date;
  end: Date;
}
